import React from "react";
import "./styles.css"
import {curatedLink} from "../Books/filters";

function AboutUs() {
    return <section className="catalog-intro" aria-labelledby="catalog-title">
        <h1 id="catalog-title">Книги по жанрам и оценкам читателей</h1>
        <p>Посмотрите каталог или уточните жанр и год. Смотреть книги можно без регистрации.</p>
    </section>;
}

export function CuratedCollections() {
    return (
        <section className="curated-collections" aria-labelledby="curated-title">
            <h2 id="curated-title">Готовые подборки</h2>
            <ul>
                <li><a href={curatedLink({yearMin: 2023, yearMax: 2023, totalGradesMin: 15, orderBy: 'total_desc'})}>Популярные книги 2023 года</a></li>
                <li><a href={curatedLink({yearMin: 0, yearMax: 2022, totalGradesMin: 60, orderBy: 'average_desc'})}>Книги с высокими оценками</a></li>
                <li><a href={curatedLink({yearMin: 1, yearMax: 2022, totalGradesMin: 400, orderBy: 'average_desc'})}>Самые популярные книги</a></li>
            </ul>
        </section>
    );
}

export default AboutUs;
